export const NOTE_NAMES_SHARP = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
export const NOTE_NAMES_FLAT = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
export const WHITE_NOTES = new Set(["C", "D", "E", "F", "G", "A", "B"]);
export const GUITAR_STRING_MIDIS = [40, 45, 50, 55, 59, 64];

export const NOTE_TO_PC = {
  C: 0,
  "C#": 1,
  Db: 1,
  D: 2,
  "D#": 3,
  Eb: 3,
  E: 4,
  Fb: 4,
  "E#": 5,
  F: 5,
  "F#": 6,
  Gb: 6,
  G: 7,
  "G#": 8,
  Ab: 8,
  A: 9,
  "A#": 10,
  Bb: 10,
  B: 11,
  Cb: 11,
};

export function mod(value, divisor) {
  return ((value % divisor) + divisor) % divisor;
}

export function notePc(note) {
  return NOTE_TO_PC[String(note || "").replace(/m$/, "")];
}

export function noteNameForPc(pc, flats = false) {
  return (flats ? NOTE_NAMES_FLAT : NOTE_NAMES_SHARP)[mod(pc, 12)];
}

export function compactRootMidi(note) {
  const pc = notePc(note);
  return pc === 0 ? 60 : 48 + pc;
}

export function noteName(midi) {
  const name = NOTE_NAMES_SHARP[mod(midi, 12)];
  const octave = Math.floor(midi / 12) - 1;
  return `${name}${octave}`;
}

export function notePitchName(value) {
  return String(value || "").replace(/\d+$/, "");
}

export function midiForPitchNear(pitch, rootMidi = 60, minMidi = 48) {
  const pc = notePc(pitch);
  if (!Number.isInteger(pc)) {
    return null;
  }

  let midi = minMidi + mod(pc - mod(minMidi, 12), 12);
  while (midi < rootMidi) {
    midi += 12;
  }
  return midi;
}
